<!-- 
Contents of the SUMMARY tab of the user page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="true"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="administration-users"
      module="prismsUsers"
      nav-url="/users/:id/summary"
    />
    <tabs :user-id="userId">
      <prisms-user-summary-panel :user-id="userId" />
    </tabs>
  </div>
</template>

<script>
import PrismsUserSummaryPanel from "@/components/prisms-users/PrismsUserSummaryPanel.vue";
import Tabs from "./Tabs.vue";
import prismsUserMixins from "./mixins";

export default {
  name: "UserSummary",
  components: { PrismsUserSummaryPanel, Tabs },
  mixins: [prismsUserMixins]
};
</script>
